import moment from "moment";
export const dateFormat = date => {
  let index = date.indexOf("T");
  return date.substring(0, index);
};

export const bookingDateFormat = date => {
  if(!date){
    throw new Error(`Can't parse bookingDateFormat, because date is undefined`);
  }
  return date.split("-");
};

export const checkAdvanceBooking = () => {};

export const convertBookingDateFormat = date => {
  // console.log({
  //   sub1: date.substring(3, 5),
  //   sub2: date.substring(0, 2),
  //   sub3: date.substring(6, 11),
  //   full: date.substring(3, 5) + "/" + date.substring(0, 2) + "/" + date.substring(6, 11),
  // });
  return date.substring(3, 5) + "/" + date.substring(0, 2) + "/" + date.substring(6, 11);
};

export const checkUserBooking = (bookings, authUser) => {
  let getAdvanceBooking = bookings.filter((booking, index) => {
    if (authUser.SgsMemberId == booking.data.memberId) {
      // moment().diff(moment(booking.data.date).add(index, "days")) < 0
      const isDateAfterToday = date => {
        const now = moment().startOf("day").toDate();
        if (date > now) {
          return true; //date is after today's date
        } else {
          return false;
        }
      };
      return (
        (isDateAfterToday(moment(convertBookingDateFormat(booking.data.date)).startOf("day").toDate()) ||
          booking.data.inAdvanceBooking) &&
        booking
      );
    }
  });

  return getAdvanceBooking;
};

export const checkAdvance = (bookings, date, dateValue, index, authUser, item, condition) => {

  let result = checkUserBooking(bookings, authUser);
  let samecourseBookings = result.length > 0 ? result.filter(res => res.data.course.id == item.id) : [];

  return samecourseBookings && samecourseBookings.length > 0 ? false : true;
};

export const checkMemberBooking = (bookings, authUser, memberId) => {
  let getAdvanceBooking = bookings.filter((booking, index) => {
    if (memberId == booking.data.memberId) {
      // moment().diff(moment(booking.data.date).add(index, "days")) < 0
      const isDateAfterToday = date => {
        const now = moment().startOf("day").toDate();
        if (date > now) {
          return true; //date is after today's date
        } else {
          return false;
        }
      };
      return (
        (isDateAfterToday(moment(convertBookingDateFormat(booking.data.date)).startOf("day").toDate()) ||
          booking.data.inAdvanceBooking) &&
        booking
      );
    }
  });

  return getAdvanceBooking;
};

export const checkAdvanceBookingMembers = (bookings, authUser, memberId, item) => {
  let result = checkMemberBooking(bookings, authUser, memberId);

  let samecourseBookings = result.length > 0 ? result.filter(res => res.data.course.id == item.id) : [];
  return samecourseBookings && samecourseBookings.length > 0 ? false : true;
};
